var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "48px_airplane",
    clipPath: "url(#clip0_18_1125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.0418 17.4L2.20951 17.1032C2.09961 17.0952 1.98989 17.1209 1.89499 17.1769C1.8001 17.2329 1.72453 17.3165 1.67839 17.4166C1.63224 17.5166 1.61771 17.6284 1.63673 17.7369C1.65575 17.8454 1.70742 17.9456 1.78484 18.024L4.18117 20.4203",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.6734 11.7759L22.8882 21.8027C23.0097 22.1818 23.0244 22.5872 22.9307 22.9742C22.837 23.3612 22.6384 23.7149 22.3568 23.9964L21.125 25.2282L15.5134 15.9364",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.0774 7.17982L5.05056 3.96503C4.67138 3.84346 4.26603 3.82874 3.87902 3.92248C3.49202 4.01622 3.13834 4.2148 2.85681 4.4964L1.62506 5.72815L10.9168 11.3398",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.45326 20.8109L9.75009 24.6437C9.75807 24.7536 9.73235 24.8633 9.67635 24.9582C9.62035 25.0531 9.53675 25.1287 9.43669 25.1748C9.33663 25.2209 9.22488 25.2355 9.11634 25.2165C9.00781 25.1974 8.90766 25.1458 8.82926 25.0684L6.43292 22.672",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.767 17.6817C12.6254 18.8235 11.3463 19.8189 9.95912 20.6451L4.35612 23.9823C4.14905 24.1058 3.90673 24.1566 3.66751 24.1268C3.42829 24.097 3.20584 23.9883 3.03538 23.8178C2.86492 23.6473 2.75619 23.4249 2.72639 23.1857C2.69659 22.9465 2.74743 22.7041 2.87087 22.4971L6.20754 16.8941C7.03409 15.5068 8.02971 14.2275 9.17153 13.0856L18.8354 3.42499C20.1045 2.15586 23.6091 1.43653 24.5148 2.34165C25.4118 3.23865 24.7006 6.75136 23.4315 8.02049L13.767 17.6817Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(6.10352e-05 0.853149)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.d90e0b4012fd6b32a323bff721e7f65c.svg";
export { ForwardRef as ReactComponent };